<script setup>
	import { ref } from 'vue';
	import { DsIconButton, dsUseIsMobile } from '@coloplast/design-system';
	import ModalGallery from 'shared/components/mediaItems/ModalGallery.vue';

	const { isMobile } = dsUseIsMobile();

	const props = defineProps({
		image: {
			type: String,
		},
		headline: {
			type: String,
		}
	});

	const showedModal = ref(false);
	const galleryItem = ref({});

	const showModal = () => {
		showedModal.value = true;
		galleryItem.value = {
			Headline: props.headline,
			Images: [
				{ ImageUrl: props.image },
			],
		};
	};

	const hideModal = () => {
		showedModal.value = false;
		galleryItem.value = null;
	};
</script>

<template>
	<div>
		<ModalGallery
			v-if="showedModal"
			:gallery-item="galleryItem"
			is-for-zoom
			@hidden-modal="hideModal"
		/>
		<DsIconButton
			v-if="!isMobile"
			type="button"
			:aria-label="headline"
			icon-name="zoom-in"
			size="md"
			variant="secondary-neutral"
			:click-handler="showModal"
		/>
	</div>
</template>
